import { ImageButton } from '../../components/button/image.button';
import { Icon } from '../../components/icon';
import { MaterialIcon } from '../../components/icon/icons';
import { IMithrilComponent } from '../../components/mithril.component';
import { Spinner } from '../../components/spinner/spinner';
import { addStyles } from '../../components/theme';
import { T, Translate } from '../../i18n/index';
import { m } from '../../mithril';
import { Services } from '../../services';
import { CSS, Style } from './omni.search.style';

addStyles(Style);

export class OmniSearch extends IMithrilComponent {
	get nodes() {
		const cancelButton = ImageButton.view(MaterialIcon.CLOSE, {
			className: CSS.clear,
			testId: 'omnisearch-clear',
			onclick: () => Services.Search.reset(),
		});

		const icon = Services.Search.inFlight
			? Spinner.view(CSS.icon)
			: Icon.view(MaterialIcon.SEARCH, { className: CSS.icon });

		return m('div', { className: CSS.container }, [
			icon,
			m('input', {
				className: CSS.input,
				'data-testid': 'omnisearch-input',
				type: 'text',
				placeholder: Translate(T.SEARCH),
				value: Services.Search.inputfilterState.filter,
				oninput: (e) => this.onChange(e),
			}),
			Services.Search.inputfilterState.hasFilter() ? cancelButton : null,
		]);
	}

	private onChange(e: Event) {
		Services.Search.inputfilterState.setFilter((e.target as HTMLInputElement).value);
	}
}
